const initialState = {
  next_payment_charged_on: undefined,
  name: '',
  amount: '',
  payment_source: {},
  id: undefined,
  starts_at: undefined,
  interval: undefined,
  interval_count: undefined,
  ends_at: undefined,
  occurrences: undefined,
  ui: {
    show: false,
    is_submitting: false,
    is_deleting: false,
  }
}

export default function(state=initialState, action){
  switch(action.type){
    case "FAILED_SUBMIT_DELETE_RECURRING_CHARGE":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
          is_deleting: false,
        }
      }
    case "SUCCESS_SUBMIT_DELETE_RECURRING_CHARGE":
      return initialState
    case "BEGIN_SUBMIT_DELETE_RECURRING_CHARGE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_deleting: true
        }
      }
    case "FAILED_SUBMIT_EDIT_RECURRING_CHARGE":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        }
      }
    case "SUCCESS_SUBMIT_EDIT_RECURRING_CHARGE":
      return initialState
    case "BEGIN_SUBMIT_EDIT_RECURRING_CHARGE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true
        }
      }
    case "RESET_EDIT_RECURRING_CHARGE":
      return initialState;
    case "LOAD_EDIT_RECURRING_CHARGE":
      return {
        ...state,
        ...action.payload,
        ui: {
          ...state.ui,
          show: true,
        }
      }
    case "UPDATE_EDIT_RECURRING_CHARGE_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_EDIT_RECURRING_CHARGE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}